// eslint-disable-next-line import/prefer-default-export
export enum EventTypes {
  PAGE,
  CUSTOM,
}

export enum Env {
  UAT = 'uat',
  STA = 'sta',
  PROD = 'prod',
}
